{
  "name": "sdlabs-web-client",
  "private": true,
  "version": "2.45.0",
  "type": "module",
  "engines": {
    "node": "24.10.0",
    "npm": "11.18.0"
  },
  "volta": {
    "node": "24.10.0",
    "npm": "11.18.0"
  },
  "scripts": {
    "setup": "concurrently \"npm run openapi\" \"npm run env:local\" \"npm run env:test\" \"npm run env:staging\" \"npm run env:production\" \"npm run playwright:install\"",
    "vite": "vite --mode localdev",
    "dev": "concurrently --kill-others \"vite --mode localdev\"",
    "build": "npm run build:local",
    "build:local": "npm run env:local && vite build --mode localdev",
    "build:test": "npm run env:test && vite build --mode test",
    "build:staging": "npm run env:staging && vite build --mode staging",
    "build:production": "npm run env:production && vite build --mode production",
    "typecheck": "npx tsgo --noEmit -p tsconfig.app.json",
    "preview": "vite preview",
    "test": "vitest run",
    "test:ci": "npm run build && npm run test:e2e",
    "test:watch": "vitest",
    "test:node": "npx vitest run --workspace=vitest.workspace.ts --project node",
    "test:browser": "vitest --workspace=vitest.workspace.ts --project node",
    "test:e2e": "npm run build:test && npm run playwright:test",
    "playwright:install": "npx playwright install",
    "playwright:test": "playwright test --config=playwright.config.ts",
    "playwright:codegen": "npx playwright codegen http://localhost:5173/",
    "lint": "npm run eslint && npm run prettier",
    "format": "npm run eslint:fix && npm run prettier:fix",
    "eslint": "eslint .",
    "eslint:fix": "npm run eslint -- --fix",
    "prettier": "npx prettier --ignore-path \".prettierignore\" --check .",
    "prettier:fix": "npm run prettier -- --write .",
    "openapi": "node scripts/generate-types.ts",
    "asyncapi": "node scripts/generate-websocket-types.ts",
    "bundle-visualizer": "vite-bundle-visualizer -c vite.config.ts --sourcemap",
    "pre-commit": "npm run typecheck && npm run format",
    "code-quality": "npm run lint && npm run typecheck && npm run build:local",
    "env:local": "ncp \"./config/.env.localdev.example\" \".env.localdev\"",
    "env:test": "ncp \"./config/.env.test.example\" \".env.test\"",
    "env:staging": "ncp \"./config/.env.staging.example\" \".env.staging\"",
    "env:production": "ncp \"./config/.env.production.example\" \".env.production\""
  },
  "dependencies": {
    "@auth0/auth0-react": "2.23.0",
    "@dnd-kit/core": "6.3.1",
    "@dnd-kit/sortable": "10.0.0",
    "@gfazioli/mantine-border-animate": "2.0.9",
    "@gfazioli/mantine-scene": "2.2.8",
    "@gfazioli/mantine-split-pane": "4.1.10",
    "@gfazioli/mantine-text-animate": "4.0.8",
    "@intercom/messenger-js-sdk": "0.0.20",
    "@mantine/charts": "9.5.1",
    "@mantine/core": "9.5.1",
    "@mantine/dropzone": "9.5.1",
    "@mantine/form": "9.5.1",
    "@mantine/hooks": "9.5.1",
    "@mantine/modals": "9.5.1",
    "@mantine/notifications": "9.5.1",
    "@mantine/spotlight": "9.5.1",
    "@mantine/tiptap": "9.5.1",
    "@sentry/react": "10.69.0",
    "@svg-fns/svg2img": "0.2.0",
    "@tiptap/core": "3.29.2",
    "@tiptap/extension-blockquote": "3.29.2",
    "@tiptap/extension-bold": "3.29.2",
    "@tiptap/extension-bubble-menu": "3.29.2",
    "@tiptap/extension-bullet-list": "3.29.2",
    "@tiptap/extension-code": "3.29.2",
    "@tiptap/extension-code-block": "3.29.2",
    "@tiptap/extension-document": "3.29.2",
    "@tiptap/extension-dropcursor": "3.29.2",
    "@tiptap/extension-floating-menu": "3.29.2",
    "@tiptap/extension-gapcursor": "3.29.2",
    "@tiptap/extension-hard-break": "3.29.2",
    "@tiptap/extension-heading": "3.29.2",
    "@tiptap/extension-horizontal-rule": "3.29.2",
    "@tiptap/extension-italic": "3.29.2",
    "@tiptap/extension-link": "3.29.2",
    "@tiptap/extension-list": "3.29.2",
    "@tiptap/extension-list-item": "3.29.2",
    "@tiptap/extension-list-keymap": "3.29.2",
    "@tiptap/extension-ordered-list": "3.29.2",
    "@tiptap/extension-paragraph": "3.29.2",
    "@tiptap/extension-placeholder": "3.29.2",
    "@tiptap/extension-strike": "3.29.2",
    "@tiptap/extension-text": "3.29.2",
    "@tiptap/extension-underline": "3.29.2",
    "@tiptap/extensions": "3.29.2",
    "@tiptap/markdown": "3.29.2",
    "@tiptap/pm": "3.29.2",
    "@tiptap/react": "3.29.2",
    "@tiptap/starter-kit": "3.29.2",
    "classnames": "^2.5.1",
    "echarts": "6.1.0",
    "echarts-for-react": "3.0.6",
    "file-saver": "2.0.5",
    "install": "0.13.0",
    "jspdf": "4.2.1",
    "lodash-es": "4.18.1",
    "mantine-datatable": "9.4.0",
    "mantine-form-valibot-resolver": "3.0.1",
    "npm": "11.18.0",
    "openapi-fetch": "0.17.0",
    "openapi-react-query": "0.5.4",
    "papaparse": "5.5.4",
    "posthog-js": "1.414.0",
    "react": "19.2.8",
    "react-dom": "19.2.8",
    "react-error-boundary": "6.1.2",
    "react-markdown": "10.1.0",
    "react-router": "8.3.0",
    "remark-gfm": "4.0.1",
    "socket.io-client": "4.8.3",
    "svg2pdf.js": "2.7.0",
    "valibot": "1.4.2",
    "zustand": "5.0.14"
  },
  "devDependencies": {
    "@asyncapi/modelina": "5.10.1",
    "@asyncapi/parser": "3.6.3",
    "@eslint-react/eslint-plugin": "5.18.3",
    "@eslint/js": "10.0.1",
    "@playwright/test": "1.62.1",
    "@rolldown/plugin-babel": "0.2.3",
    "@sentry/vite-plugin": "5.4.0",
    "@tanstack/react-query-devtools": "5.101.4",
    "@trivago/prettier-plugin-sort-imports": "6.0.2",
    "@types/file-saver": "2.0.7",
    "@types/lodash-es": "4.17.12",
    "@types/papaparse": "5.5.2",
    "@types/react": "19.2.18",
    "@types/react-dom": "19.2.4",
    "@typescript/native-preview": "7.0.0-dev.20260707.2",
    "@vitejs/plugin-react": "6.0.5",
    "@vitest/browser": "4.1.10",
    "@vitest/browser-playwright": "4.1.10",
    "babel-plugin-react-compiler": "1.0.0",
    "concurrently": "10.0.4",
    "eslint": "10.8.1",
    "eslint-config-prettier": "10.1.8",
    "eslint-import-resolver-typescript": "4.4.5",
    "eslint-plugin-check-file": "3.3.2",
    "eslint-plugin-import-x": "4.17.1",
    "eslint-plugin-playwright": "2.11.0",
    "eslint-plugin-react-hooks": "7.1.1",
    "eslint-plugin-react-refresh": "0.5.3",
    "globals": "17.9.0",
    "ncp": "2.0.0",
    "npm-check-updates": "22.2.9",
    "openapi-typescript": "7.13.0",
    "playwright": "1.62.1",
    "postcss-preset-mantine": "^1.18.0",
    "prettier": "3.9.6",
    "socket.io": "4.8.3",
    "typescript-eslint": "8.66.0",
    "vite": "8.2.1",
    "vite-bundle-visualizer": "1.2.1",
    "vitest": "4.1.10",
    "vitest-browser-react": "2.2.0",
    "yaml": "2.9.0"
  },
  "optionalDependencies": {
    "@rollup/rollup-linux-x64-gnu": "4.62.4"
  },
  "overrides": {
    "rollup-plugin-visualizer": {
      "rolldown": ">=1.0.0-rc.0"
    },
    "@eslint/js": {
      "eslint": "$eslint"
    },
    "@tiptap/core": "$@tiptap/core",
    "@tiptap/extension-blockquote": "$@tiptap/extension-blockquote",
    "@tiptap/extension-bold": "$@tiptap/extension-bold",
    "@tiptap/extension-bubble-menu": "$@tiptap/extension-bubble-menu",
    "@tiptap/extension-bullet-list": "$@tiptap/extension-bullet-list",
    "@tiptap/extension-code": "$@tiptap/extension-code",
    "@tiptap/extension-code-block": "$@tiptap/extension-code-block",
    "@tiptap/extension-document": "$@tiptap/extension-document",
    "@tiptap/extension-dropcursor": "$@tiptap/extension-dropcursor",
    "@tiptap/extension-floating-menu": "$@tiptap/extension-floating-menu",
    "@tiptap/extension-gapcursor": "$@tiptap/extension-gapcursor",
    "@tiptap/extension-hard-break": "$@tiptap/extension-hard-break",
    "@tiptap/extension-heading": "$@tiptap/extension-heading",
    "@tiptap/extension-horizontal-rule": "$@tiptap/extension-horizontal-rule",
    "@tiptap/extension-italic": "$@tiptap/extension-italic",
    "@tiptap/extension-link": "$@tiptap/extension-link",
    "@tiptap/extension-list": "$@tiptap/extension-list",
    "@tiptap/extension-list-item": "$@tiptap/extension-list-item",
    "@tiptap/extension-list-keymap": "$@tiptap/extension-list-keymap",
    "@tiptap/extension-ordered-list": "$@tiptap/extension-ordered-list",
    "@tiptap/extension-paragraph": "$@tiptap/extension-paragraph",
    "@tiptap/extension-placeholder": "$@tiptap/extension-placeholder",
    "@tiptap/extension-strike": "$@tiptap/extension-strike",
    "@tiptap/extension-text": "$@tiptap/extension-text",
    "@tiptap/extension-underline": "$@tiptap/extension-underline",
    "@tiptap/extensions": "$@tiptap/extensions",
    "@tiptap/markdown": "$@tiptap/markdown",
    "@tiptap/pm": "$@tiptap/pm",
    "@tiptap/react": "$@tiptap/react",
    "@tiptap/starter-kit": "$@tiptap/starter-kit"
  },
  "allowScripts": {
    "@hyperjump/json-pointer@0.9.8": true,
    "@hyperjump/json-schema-core@0.28.5": true,
    "@hyperjump/pact@0.2.5": true,
    "@hyperjump/json-schema@0.23.5": true,
    "@scarf/scarf": false,
    "browser-tabs-lock": false,
    "core-js": false,
    "protobufjs": false,
    "unrs-resolver": false,
    "fsevents": false,
    "@sentry/cli": false
  }
}
